
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('account_type')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('name')}}</th>
                            <th>{{ $t('group') }}</th>
                            <th>{{ $t('description') }}</th>
                            <th class="text-center">{{ $t('sort')}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Name}}</td>
                            <td>{{ret.Type}}</td>
                            <td>{{ret.Description}}</td>
                            <td class="text-center">{{ret.Sort}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                records: []
            };
        },
        created: function() {
            this.init();
        },
        methods: {
            init: function() {
                var loading = this.$loading.show();
                this.$api().post('accounting/types', {}).then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    };
</script>